module.exports = __webpack_public_path__ + "img/SAI.9e293c43.jpg";